import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  ListVopRequestParams,
  VopRequestResult,
  VopRequestService,
  VopRequestStatus,
} from 'src/app/core/vop-request.service';

@Component({
  selector: 'app-vop-request-filter-dialog',
  templateUrl: './vop-request-filter-dialog.component.html',
  styleUrls: ['./vop-request-filter-dialog.component.scss'],
})
export class VopRequestFilterDialogComponent {
  vop_requests_filters_from_group: FormGroup = this.form_service.vop_requests_filters_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  company_agreement_list: string[] = [];
  is_list_running: boolean = false;
  pending: VopRequestStatus = VopRequestStatus.pending;
  succeeded: VopRequestStatus = VopRequestStatus.succeeded;
  failed: VopRequestStatus = VopRequestStatus.failed;
  CMTC: VopRequestResult = VopRequestResult.CMTC;
  MTCH: VopRequestResult = VopRequestResult.MTCH;
  NMTC: VopRequestResult = VopRequestResult.NMTC;

  constructor(
    private dialog_ref: MatDialogRef<VopRequestFilterDialogComponent>,
    private utils_service: UtilsService,
    private form_service: FormService,
    private vop_requests_service: VopRequestService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const vop_request_id: string = this.vop_requests_filters_from_group.get(
        this.form_service.vop_request_id_label,
      )?.value;
      const status: string = this.vop_requests_filters_from_group.get(this.form_service.status_label)?.value;
      const result: string = this.vop_requests_filters_from_group.get(this.form_service.result_label)?.value;
      const beneficiary_firstname: string = this.vop_requests_filters_from_group.get(
        this.form_service.beneficiary_firstname_label,
      )?.value;
      const beneficiary_lastname: string = this.vop_requests_filters_from_group.get(
        this.form_service.beneficiary_lastname_label,
      )?.value;
      const beneficiary_tax_code: string = this.vop_requests_filters_from_group.get(
        this.form_service.beneficiary_tax_code_label,
      )?.value;
      const beneficiary_iban: string = this.vop_requests_filters_from_group.get(
        this.form_service.beneficiary_iban_label,
      )?.value;
      const buyer_id: string = this.vop_requests_filters_from_group.get(this.form_service.buyer_id_label)?.value;
      const order_id: string = this.vop_requests_filters_from_group.get(this.form_service.order_id_label)?.value;
      const params: ListVopRequestParams = {
        vop_request_id: vop_request_id == '' ? undefined : vop_request_id,
        status: status == '' ? undefined : (status as VopRequestStatus),
        result: result == '' ? undefined : (result as VopRequestResult),
        beneficiary_firstname: beneficiary_firstname == '' ? undefined : beneficiary_firstname,
        beneficiary_lastname: beneficiary_lastname == '' ? undefined : beneficiary_lastname,
        beneficiary_tax_code: beneficiary_tax_code == '' ? undefined : beneficiary_tax_code,
        beneficiary_iban: beneficiary_iban == '' ? undefined : beneficiary_iban,
        order_id: order_id == '' ? undefined : order_id,
        buyer_id: buyer_id == '' ? undefined : buyer_id,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.vop_requests_filters_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.vop_requests_filters_from_group);
  }

  getVopRequestStatusLabel(status: VopRequestStatus): string {
    return this.utils_service.getVopRequestStatusLabel(status);
  }
}
